export const CONTACT_EMAIL = 'lucas@iclcollective.com'
export const CONTACT_PHONE = '+54 9 11 3583-2093'
export const CONTACT_ADDRESS = 'Uruguay 1259, Buenos Aires, Argentina'
export const MAILTO = `mailto:${CONTACT_EMAIL}`

export const navLinks = [
  { label: 'Services', href: '#services' },
  { label: 'Clients', href: '#clients' },
  { label: 'About', href: '#about' },
  { label: 'Contact', href: '#contact' },
]

export type ServiceIcon = 'paid' | 'social' | 'pages' | 'analytics'

export const services: {
  icon: ServiceIcon
  title: string
  description: string[]
}[] = [
  {
    icon: 'paid',
    title: 'Paid Media Management (Google & Meta Ads)',
    description: [
      'We plan, launch and manage search, shopping and social campaigns across Google and Meta.',
      'Budgets, audiences and creative are reviewed on an ongoing basis and adjusted with your input.',
    ],
  },
  {
    icon: 'social',
    title: 'Social Media Management',
    description: [
      'Content calendars, publishing and community management for your brand channels.',
      'Each plan is agreed in advance so you always know what is being published and when.',
    ],
  },
  {
    icon: 'pages',
    title: 'Landing Pages & Funnels',
    description: [
      'We design and build landing pages and lead capture flows aligned with your campaigns.',
      'Pages are tracked end to end so enquiries can be attributed to the right channel.',
    ],
  },
  {
    icon: 'analytics',
    title: 'Analytics & Reporting',
    description: [
      'Tracking setup, dashboards and a clear monthly report covering spend and activity.',
      'We review the numbers with you and document what we plan to do next.',
    ],
  },
]

export const clients = [
  {
    title: 'E-commerce brands',
    description:
      'Online retailers that need consistent campaign management across their product catalogue and sales channels.',
  },
  {
    title: 'Professional service businesses',
    description:
      'Firms and practices that rely on a steady flow of qualified enquiries from search and social.',
  },
  {
    title: 'Small and mid-sized companies',
    description:
      'Established businesses expanding their online presence and formalising how their marketing is measured.',
  },
]

export const steps = [
  {
    number: '1',
    title: 'Discovery call',
    description:
      'We review your current marketing, objectives and budget, and confirm whether we are the right fit.',
  },
  {
    number: '2',
    title: 'Strategy & setup',
    description:
      'We agree the scope, prepare accounts and tracking, and document the plan before anything goes live.',
  },
  {
    number: '3',
    title: 'Execution & monthly reporting',
    description:
      'We manage campaigns day to day and share a written monthly report with spend, activity and next steps.',
  },
]

export const aboutParagraph =
  'ICL Collective is a marketing services company operated by ICL Collective LLC, registered in Delaware, USA, with operations based in Buenos Aires, Argentina. We work with clients across the Americas, combining hands-on campaign management with transparent, data-driven reporting.'
